import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  HttpLink,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import fetch from 'unfetch';
import {
  akamaiCaching,
  hasHeaders,
  isCacheableHeader,
  queryClassificationHeader,
  queryDebug,
  sourceHeader,
  trackGraphQLErrors,
  uid,
  geoLocationHeader,
} from '@express-labs/raven-middleware';

const ignoreList = [];

const httpLink = new HttpLink({
  credentials: 'same-origin',
  // This file is also used in jest tests where global.fetch is defined
  // eslint-disable-next-line no-undef
  // fetch: global.fetch || fetch,
  fetch,
  uri: '/graphql',
});

const middlewares = [
  hasHeaders,
  akamaiCaching,
  queryClassificationHeader,
  sourceHeader('app_express.com'),
  isCacheableHeader,
  uid,
  geoLocationHeader,
];

if (window.isDebugMode) middlewares.push(queryDebug);

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(trackGraphQLErrors(ignoreList)),
    ...middlewares,
    httpLink,
  ]),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

export default client;
